<template>
  <!-- Ajuste visual 3: el tooltip con el texto completo solo aparece en la variante grande y si el texto se corta con «…» -->
  <Badge :value="label" :severity="severity" class="zapi-badge-pill" :class="{ 'zapi-badge-pill--grande': grande }"
    v-tooltip.bottom="grande && cortado ? label : null" />
</template>

<script>
export default {
  name: 'ZapiBadgePill',
  props: {
    label: { type: String, required: true },
    severity: { type: String, default: 'danger' },
    // Opcional: versión más grande y legible (encabezado del POS). Por defecto no cambia el aspecto.
    grande: { type: Boolean, default: false }
  },
  data() {
    return { cortado: false };
  },
  watch: {
    label() {
      this.$nextTick(this.medirCorte);
    }
  },
  mounted() {
    this.$nextTick(this.medirCorte);
  },
  methods: {
    // Marca si el texto no cabe (se ve con «…»), para mostrar el nombre completo en el tooltip
    medirCorte() {
      const el = this.$el;
      this.cortado = !!(this.grande && el && el.scrollWidth > el.clientWidth);
    }
  }
}
</script>

<style scoped>
.zapi-badge-pill,
.zapi-badge-pill :deep(.p-badge) {
  border-radius: 999px !important;
  white-space: nowrap !important; /* Mantiene el texto en una sola línea horizontal */
  height: auto !important; /* Quita el alto fijo por defecto de PrimeVue */
  min-height: 1.5rem;
  padding: 0.25rem 0.6rem;
  line-height: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

/* Variante grande (prop `grande`): letra mayor, negrita, más padding y corte con «…» si no cabe */
.zapi-badge-pill.zapi-badge-pill--grande {
  font-size: 1rem;
  font-weight: 700;
  padding: 0.4rem 0.9rem;
  display: inline-block;
  /* Ajuste visual 3: antes max-width: 18rem. Ahora 22rem y no se encoge dentro de un flex: solo se corta si pasa de 22rem */
  max-width: 22rem;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>